import React, { Component, PropTypes } from 'react';
import { hashHistory, Link } from 'react-router';
import FolderHierarchy from './FolderHierarchy';
import { ToastContainer, ToastMessage } from 'react-toastr';
// import DevTools from 'mobx-react-devtools';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { auth, user } from "../actions/api";
import { preference, token } from "../libs/localStorage";
import Cookies from "js-cookie";
import { IconButton } from './Form';
const ToastMessageFactory = React.createFactory(ToastMessage.animation);

@inject('uiStore', 'folderStore', 'rolePermissionStore', 'stationPermissionStore', 'userPreferenceStore', 'stationStore')
@observer
class Root extends Component {
  static propTypes = {
    children: PropTypes.shape(),
    route: PropTypes.shape().isRequired,
    folderStore: PropTypes.object.isRequired,
    uiStore: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    notify: PropTypes.shape().isRequired,
  };

  events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress"
  ];

  getChildContext() {
    const timeOut = 3000;
    const extendedTimeOut = 1000;
    const style = { opacity: 1 };
    const notify = {
      error: ({ message }) => {
        console.trace(message)
        this._toast.error(message, null, { timeOut, extendedTimeOut, style });
      },
      success: (successObj) => {
        const message = successObj ? successObj && successObj.message : 'Success';
        this._toast.success(message, null, { timeOut, extendedTimeOut, style });
      },
      startLoading: ({ message }) => {
        this._toast.info(message || 'Loading', null, { style, timeOut: 1000000000, extendedTimeOut: 100000000 });
      },
      stopLoading: () => {
        this._toast.clear();
      }
    };
    return { notify };
  }

  componentWillMount() {
    const { rolePermissionStore, stationPermissionStore, userPreferenceStore, folderStore, stationStore } = this.props;
    folderStore.fetchItems();
    stationStore.fetchItems();
    rolePermissionStore.fetchAllRoles();

    stationPermissionStore.fetchUserStationPermissions(token.getDecoded().id);

    userPreferenceStore._fetchAll().then(res => {
      if (!!res[0]) preference.set(res[0]);
    });

    user.fetchById(token.getDecoded().id).then(res => {
      rolePermissionStore
        .fetchRolesById(res.role_id)
        .then(res => {
          let permissionArray = res.map(perm => perm.permission);
          token.setPermissions(permissionArray);
        });
    });
  }

  componentDidMount() {
    this._toast = this.refs.toast;
    window.onclick = function (event) {
      if (!event.target.matches('.dropbtn')) {
        let dropdowns = document.getElementsByClassName("dropdown-content");
        for (let i = 0; i < dropdowns.length; i++) {
          let openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    };

    // this.events.forEach(event => {
    //   window.addEventListener(event, this.resetTimeout)
    // });
    // this.setTimeout();
  }

  clearTimeout = () => {
    if (this.warnTimeout) clearTimeout(this.warnTimeout);
    if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
  };

  setTimeout = () => {
    this.warnTimeout = setTimeout(this.warn, 29 * 60 * 1000);
    this.logoutTimeout = setTimeout(this.logout, 30 * 60 * 1000);
  };

  resetTimeout = () => {
    this.clearTimeout();
    this.setTimeout();
  };

  warn = () => {
    this._toast.warning("You will be logged out automatically in 1 minute.", null, { timeOut: 5000, extendedTimeOut: 1000 });
  };

  logout() {
    auth.logout().then(() => {
      hashHistory.replace('/logout')
    })
  }

  render() {
    const { children, folderStore, uiStore } = this.props;
    const cookie = Cookies.get('app_config');
    let app_config = !!cookie && JSON.parse(cookie);

    return (
      <div>
        <ToastContainer ref="toast" className="toast-bottom-right" toastMessageFactory={ToastMessageFactory} />
        <div className="Sidebar" style={uiStore.mobileView ? { marginLeft: uiStore.isNavOpen ? '0' : '-100%', width: '80vw' } : { width: uiStore.navWidth }}>
          {/* <div style={{ width: uiStore.mobileView ? '100%' : 'calc(100% - 10px)' }}> */}
          <div style={{ width: '100%' }}>
            <div className="SidebarHeader">
              <Link to={'/'}>{(app_config && app_config.app_title) || 'WSCADA.NET'}</Link>
              {uiStore.mobileView && <IconButton icon="fa fa-arrow-left" onClick={() => uiStore.toggleNav()} color='#367fa9' primary />}
            </div>
            <FolderHierarchy folderStore={folderStore} />
          </div>
        </div>
        <div className="MainSection" style={{ marginLeft: uiStore.mobileView ? 0 : uiStore.navWidth }}>
          {children}
          <div className='mainsection-overlay' onClick={() => uiStore.mobileView && uiStore.toggleNav()} style={uiStore.mobileView && uiStore.isNavOpen ? { opacity: 1, zIndex: 9999 } : { opacity: 0, zIndex: -100 }} />
        </div>
        {/*
        <DevTools />
        */}
      </div>
    );
  }
}

export default Root;




// WEBPACK FOOTER //
// ./src/components/Root.js